
export interface User {
    name: string;
    last_login_at: string | null;
    last_login_ip: string | null;
    profile_photo_url: string;
    username: string;
    user_verified_at: string;
    access_type: AccessType;
    is_test: boolean;
    referral_code: string;
    agencies: Agency[];
    uuid: string
}

enum AccessType {
    AGENCY = 'agency',
    INFLUENCER = 'influencer'
}

export interface UserProfileResponse {
    user: User,
    master: any,
    configurations: any
}

export interface Agency {
    uuid: string,
    name: string,
    role: {
        name: string,
        slug: string
    },
    type: string,
    privileges: string[],
    notification_preferences: string[],
    configurations: Record<string, any>,
    onboarding_steps: Record<string, {status: 'complete' | 'pending' | 'skip', ts?: string, sort_order: number}>
}

export const onboardingStepSortOrder = {
    type: 1,
    website_url: 2,
    social_account: 3,
    gst: 4
}